export default __webpack_public_path__ + "static/pine branch-f4de997fc3e26414c1e9ca27b83b8293.png";